export class Chance {
  static LOW = 1
  static LOW_MEDIUM = 2
  static MEDIUM = 3
  static MEDIUM_HIGH = 4
  static HIGH = 5
  static INSUFFICIENT_DATA = 0
}
